/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Live_BodyInputs */

const en_features_live_body = /** @type {(inputs: Features_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You type the exercises as you go and your client sees them on their phone straight away. Logged sets come back to you and count towards their recovery.`)
};

const pl_features_live_body = /** @type {(inputs: Features_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpisujesz ćwiczenia w trakcie, a podopieczny widzi je w telefonie od razu. Zaliczone serie wracają do Ciebie i liczą się do jego regeneracji.`)
};

/**
* | output |
* | --- |
* | "You type the exercises as you go and your client sees them on their phone straight away. Logged sets come back to you and count towards their recovery." |
*
* @param {Features_Live_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_live_body = /** @type {((inputs?: Features_Live_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Live_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_live_body(inputs)
	return en_features_live_body(inputs)
});